/* Chart utilities copied from charts.js originally, separated into specifically serverStats  */

// site-wide default for bar width. If series don't specify maxPointWidth, this
// will be used.
var globalMaxPointWidth = 40;

function formatMB(mb, decimals = 2) {
  if (mb === "" || mb ==0){
    return {
      'value': 0,
      'unit': 'MB'
    }
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(mb) / Math.log(k))

  // return `${parseFloat((mb / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  return {
    'value': `${parseFloat((mb / Math.pow(k, i)).toFixed(dm))}`,
    'unit': `${sizes[i]}`
  }
}

function formatBytes(bytes, decimals = 2) {
  if (bytes === "" || bytes ==0){
    return {
      'value': 0,
      'unit': 'B'
    }
  }

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  // return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  return {
    'value': `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}`,
    'unit': `${sizes[i]}`
  }
}

(function (c2, $, _, Highcharts) {
  'use strict';

  // Provide a maxPointWidth setting to Hichcharts to enable max bar widths in
  // pixels. Extends the Highcharts.drawPoints function.
  // When initializing a chart, set it on any series like this:
  //    series: [{maxPointWidth: 25, data: seriesData}]
  (function(H) {
    var each = H.each;
    H.wrap(H.seriesTypes.column.prototype, 'drawPoints', function(proceed) {
      var series = this;
      var maxPointWidth = (typeof(series.options.maxPointWidth) === undefined) ?
          globalMaxPointWidth : series.options.maxPointWidth;
      if(series.data.length > 0 ){
        var width = series.barW > maxPointWidth ? maxPointWidth : series.barW;
        each(this.data, function(point) {
          point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
          point.shapeArgs.width = width;
        });
      }
      proceed.call(this);
    });
  })(Highcharts);


  // Sum an array of numbers after filtering out `null` values.
  function sum(values) {
    var filtered_values, n, i, s = 0;

    filtered_values = _.without(values, null);
    n = filtered_values.length;

    if (n == 0) {
      return 0;
    }

    for (i = 0; i < n; i++) {
      s += filtered_values[i];
    }
    return s;
  }


  // Given an array of numbers, calculate their average
  function avg(values) {
    var filtered_values,
        total_value,
        n = values.length;
    if (n === 0) {
      return 0;
    }

    // The `.without` function will remove the `null`'s that we used to replace
    // empty values with in our `values` array, allowing us to correctly
    // calculate the average.
    filtered_values = _.without(values, null);
    total_value = sum(filtered_values);
    if (total_value == 0 || filtered_values.length == 0) {
      return 0;
    }
    return total_value / filtered_values.length;
  }

  // Returns null for missing float values, allowing us to plot empty data on
  // the chart. If the value can be converted to a float, treat it as such and
  // divide by the denominator.
  function parseFloatNull(value, denominator) {
    var nan_values = ['', 'null'];
    if (nan_values.includes(value)) {
      return null;
    }

    return parseFloat(value) / denominator;
  }

  function getAllValues(data){
    let name = [];
    let usage_date = [];
    let cost = [];
    let graphType =  '';
    for(let i=0; i<data.length; i++){
      for(let j=0; j<data[i].points.length; j++){
        name.push(data[i].name);
        usage_date.push(data[i].points[j].category.toUTCString());
        cost.push(data[i].points[j].y);
        graphType = data[i].points[j].graphType
      }
    }
    return {"name": name, "usage_date": usage_date, "cost": cost, "graphType": graphType};
  }

  // default export menu items
  var exportingOptions = {
    filename: 'Date-wise Cost Details',
    toCSV: function(values) {
      let headers = [];
      let all_values = [];
      all_values = getAllValues(values);
      let name = all_values.name;
      let usage_date = all_values.usage_date;
      let cost = all_values.cost;
      let graphType = all_values.graphType;
      if (graphType == "Group"){
        headers = ['Resource Handler', 'UsageDate', 'Cost']
      }
      else if(graphType == "Server"){
        headers = ['Type', 'UsageDate', 'Cost']
      }

      return c2.downloads.arrayToCSV(
        headers, _.zip(name, usage_date, cost));
    },
    buttons: {
      contextButton: {
        menuItems: [
          {
            text: gettext('Print'),
            onclick: function() {
              this.print();
            }
          },
          { separator: true },
          {
            text: gettext('Export as PNG Image'),
            onclick: function() {
              c2.charts.exportChartAsPNG(this, this.options.exporting.filename + '.png');
            }
          },
          {
            text: gettext('Export as CSV'),
            onclick: function() {
              // The report configuration defines toCSV, a non-standard
              // Highcharts option, so that this handler remains generic.
              c2.downloads.startDownloadFromContent(
                this.options.exporting.toCSV(this.series),
                this.options.exporting.filename + '.csv');
            }
          }
        ]
      }
    }
  };

  var serverBarChartDefaults = {
    subtitle: {
      text: gettext('Includes all servers in groups you have permission to view.')
    },
    yAxis: {
      title: { text: gettext('Number of Servers') }
    },
    series: [
      {
        name: gettext('Servers'),
        maxPointWidth: 40,
      }
    ],
    chart: {
      type: 'bar'
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b>'
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    exporting: exportingOptions
  };

  var serverPieChartDefaults = {
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          color: '#000000',
          connectorColor: '#000000',
          formatter: function() {
            return '<b>'+ this.point.name +'</b>: '+ this.point.y + gettext(' servers');
          }
        }
      }
    },
    subtitle: {
      text: gettext('Includes all servers in groups you have permission to view.')
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f} %</b>'
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    exporting: exportingOptions
  };

  var billingSeriesDefaults = {
    title: {
      text: ""
    },
    yAxis: {
      labels: {
        format: '${value:.2f}',
      },
      title: {
        text: "Cost (USD)"
      }
    },
    xAxis: {
      type: 'datetime',
      tickInterval: 5,
      labels: {
        format: '{value:%e %b %Y}'
      },
    },
    tooltip: {
      headerFormat: '<b>{point.x:%e %b %Y}</b> <br>',
      pointFormat: '{series.name}: <b>${point.y:.2f}</b>',
    },
    series: {
      type: 'spline'
    },
    credits: {
      enabled: false
    },
    exporting: exportingOptions,
    chart: {
      zoomType: 'xy'
    },
  };

  var commonStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        format: '{value} %',
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: gettext('Percentage'),
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var openstackCPUStatChartOpts = {
    chart: {
      zoomType: 'xy',
      events: {
        load: function() {
          let dataMax = this.yAxis[0].dataMax;

          if (dataMax > 100) {
            this.yAxis[0].update({
              max: 100
            });
          } else {
            this.yAxis[0].update({
              max: dataMax
            });
          }
        }
      }
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        format: '{value} %',
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: gettext('Percentage'),
        style: {
          color: '#335b83'
        }
      },
      max: 100,
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var memStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        formatter: function() {
          var current_value = this.value;
          return `${formatMB(current_value).value} ${formatMB(current_value).unit}`
        },
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: gettext('Memory Usage'),
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var diskStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        format: '{value} kB/s',
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: 'Disk I/O (in kB/s)',
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var netStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        format: '{value} kB/s',
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: 'Throughput (in kB/s)',
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var openstackDiskStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        formatter: function() {
          var current_value = this.value;
          return `${formatBytes(current_value).value} ${formatBytes(current_value).unit}`
        },
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: 'Disk Usage',
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  var openstackNetStatChartOpts = {
    chart: {
      zoomType: 'xy'
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime',
      tickPixelInterval: 150
    },
    yAxis: { // Primary yAxis
      labels: {
        formatter: function() {
          var current_value = this.value;
          return `${formatBytes(current_value).value} ${formatBytes(current_value).unit}`
        },
        style: {
          color: '#335b83'
        }
      },
      title: {
        text: 'Network Usage',
        style: {
          color: '#335b83'
        }
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };


  /* Creates series data array of objects, with markers added where
   * server events occur.
   *
   * Returns object:
   * {
   *   data: the series data points
   *   average: average value of numbers in data array
   *   eventAtTime: a dict of events by time used to generate tooltips
   * }
   *
   * Markers are drawn on the series wherever event times correspond with
   * series times. Since exact matches between event millisecond times and
   * series times are unlikely, markers are added to the next x value
   * after the time they happened.
   * Args:
   *   pointValues: array of numbers
   *   serverEventsSorted: array of event objects in chronological order
   *   interval: distance in seconds between each point
   *   isPercentage: boolean indicating whether the provided pointValues are percentage
        values or not (CPU and Memory data points are, whereas disk and network data points are not)
   */
  function seriesData(startTime, interval, pointValues, serverEventsSorted, isPercentage) {
    var data = [];
    var intervalInMS = interval * 1000;
    var x, i, k, point, event;
    // dict of server history events on a particular x value (time), used
    // by tooltips
    var eventAtTime = {};

    if (isPercentage) {
      var denominator = 100.0;
    }
    else {
      var denominator = 1.0;
    }
    for (i = 0; i < pointValues.length; i++) {
      x = startTime + (i * intervalInMS);
      let pointVal = pointValues[i] ? pointValues[i] : 0
      point = {
        x: x,
        //Previously, Math.round() was rounding values less than 0.5% down to 0%.
        y: isPercentage ? parseFloat((parseFloatNull(pointVal, denominator) * 100).toFixed(2)) :
        parseFloat((parseFloatNull(pointVal, denominator)).toFixed(2)),
        marker: {
          enabled: false
        }
      };

      // go through the events that haven't been processed yet and
      // add them to the series if they happened before this point.
      for (k = 0; k < serverEventsSorted.length; k++) {
        event = serverEventsSorted[k];
        if (point.x > event.epoch_ms) {
          //point.color = '#393';
          point.marker = {
            enabled: true,
            fillColor: '#393',
            lineColor: '#060',
            radius: 10,
            symbol: 'diamond'
          //symbol: url('event-type-icon.png')
          };

          // data used by tooltip
          eventAtTime[point.x] = event;

          // remove it from the list of events
          serverEventsSorted.splice(k, 1);
        }
      }

      data.push(point);
    }

    return {
      data: data,
      eventAtTime: eventAtTime,
      average: avg(_.map(data, 'y'))
    };
  }

  /* Given a data series, return the Highcharts tooltip option object.
   * Series object should include the eventAtTime dict that is needed
   * to look up event information.
   *
   * The percentage arg is a boolean to indicate whether to present
   * each point as percentages or as real numbers.
   */
  function getServerStatTooltip(series, percentage, openstackTitleFlag, is_memory_stat) {
    return {
      formatter: function() {
        var s = '<b>'+ Highcharts.dateFormat('%b %e %Y at %H:%M:%S', this.x) +'</b>';

        _.forEach(this.points, function(point) {
          if (percentage) {
            s += '<br/>'+ point.series.name +': <b>'+ point.y +'% </b>';
          }
          else if (openstackTitleFlag && is_memory_stat) {
            s += '<br/>' + point.series.name + ': <b>' + `${formatMB(point.y).value} ${formatMB(point.y).unit}` + '</b>';
          }
          else if (openstackTitleFlag && !is_memory_stat) {
            s += '<br/>' + point.series.name + ': <b>' + `${formatBytes(point.y).value} ${formatBytes(point.y).unit}` + '</b>';
          }
          else{
            s += '<br/>'+ point.series.name +': <b>'+ point.y +'</b>';
          }

        });

        if (series.eventAtTime[this.x] !== undefined) {
          var e = series.eventAtTime[this.x];
          // add server event info
          s += '<div class="chart-tip event-tip">';
          s += 'Event: <b>'+ e.type +'</b><br/>';
          s += 'Owner: <b>'+ e.owner_html +'</b><br/>';
          s += 'Job: <b>'+ e.job_html +'</b><br/>';
          s += '<p style="white-space: normal; overflow-wrap: break-word;">'+ e.message +'</p>';
          s += '</div>';
        }

        return s;
      },
      useHTML: true,
      shared: true
    };
  }


  /* Draw chart of CPU stats with server history events added as markers
   * on the line.
   * Args:
   *     startTime: epoch seconds
   *     interval: seconds between each x value
   *     cpuUsageValues: array of float numbers representing % values
   *     serverEvents: array of event objects
   *     options: Highchart options object
   */
  function drawServerCPUStatsChart(
      startTime, interval, cpuUsageValues, serverEvents, options, openstackTitleFlag) {
    if (cpuUsageValues === undefined) {
        cpuUsageValues = [];
    }
    let isPercent = true

    // array of event objects sorted chronologically
    var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
    var series = seriesData(startTime, interval, cpuUsageValues, serverEventsSorted, isPercent);

    $('#cpu-container').highcharts(_.merge({
      subtitle: {
        text: gettext('CPU Stats')
      },
      series: [
        {
          name: 'Usage',
          color: '#335b83',
          type: 'line',
          data: series.data
        }, {
          name: 'Average',
          color: '#4a9de4',
          type: 'spline',
          marker: { enabled: false },
          data: (function() {
            var i,
                points = [],
                n = series.data.length;
            for (i = 0; i < n; i++) {
              points.push({
                x: series.data[i].x,
                y: Math.round(series.average * 100) / 100
              });
            }
            return points;
        }())
      }],
      tooltip: getServerStatTooltip(series, isPercent, openstackTitleFlag, false)
    }, options));
  }


  /* Draw chart of memory stats with server history events added as markers
   * on the line.
   * Args:
   *     startTime: epoch seconds
   *     interval: seconds between each x value
   *     memUsageValues: array of float numbers representing % values
   *     serverEvents: array of event objects
   *     options: Highchart options object
   */
  function drawServerMemStatsChart(
      startTime, interval, memUsageValues, serverEvents, options, openstackTitleFlag) {
    if (memUsageValues === undefined) {
        memUsageValues = [];
    }
    let isPercent = true
    if (openstackTitleFlag === true){
      isPercent = false
    }
    // array of event objects sorted chronologically
    var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
    var series = seriesData(startTime, interval, memUsageValues, serverEventsSorted, isPercent);
    $('#mem-container').highcharts(_.merge({
      subtitle: {
        text: gettext('Memory Stats')
      },
      series: [
        {
          name: 'Usage',
          color: '#335b83',
          type: 'line',
          data: series.data
        }, {
          name: 'Average',
          color: '#4a9de4',
          type: 'spline',
          marker: { enabled: false },
          data: (function() {
            var i,
                points = [],
                n = series.data.length;
            for (i = 0; i < n; i++) {
              points.push({
                x: series.data[i].x,
                y: Math.round(series.average * 100) / 100
              });
            }
            return points;
        }())
      }],
      tooltip: getServerStatTooltip(series, isPercent, openstackTitleFlag, true)
    }, options));
  }


  /* Draw chart of disk usage stats with server history events added as markers
   * on the line.
   * Args:
   *     startTime: epoch seconds
   *     interval: seconds between each x value
   *     diskUsageValues: array of float numbers representing disk usage values
   *     serverEvents: array of event objects
   *     options: Highchart options object
   */
  function drawServerDiskStatsChart(
      startTime, interval, diskUsageValues, serverEvents, options, openstackTitleFlag) {
    if (diskUsageValues === undefined) {
        diskUsageValues = [];
    }

    // array of event objects sorted chronologically
    var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
    var series = seriesData(startTime, interval, diskUsageValues, serverEventsSorted, false);
    var titleText = 'Disk Stats';
    if(openstackTitleFlag == true){
      titleText = "Disk Read Stats";
    }
    $('#disk-container').highcharts(_.merge({
      subtitle: {
        text: gettext(titleText)
      },
      series: [
        {
          name: 'Rate',
          color: '#335b83',
          type: 'line',
          data: series.data
        }, {
          name: 'Average',
          color: '#4a9de4',
          type: 'spline',
          marker: { enabled: false },
          data: (function() {
            var i,
                points = [],
                n = series.data.length;
            for (i = 0; i < n; i++) {
              points.push({
                x: series.data[i].x,
                y: Math.round(series.average * 100) / 100
              });
            }
            return points;
        }())
      }],
      tooltip: getServerStatTooltip(series, false, openstackTitleFlag, false)
    }, options));
  }

  function drawServerDiskWriteStatsChart(
    startTime, interval, diskUsageValues, serverEvents, options, openstackTitleFlag) {
  if (diskUsageValues === undefined) {
      diskUsageValues = [];
  }

  // array of event objects sorted chronologically
  var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
  var series = seriesData(startTime, interval, diskUsageValues, serverEventsSorted, false);

  $('#disk-write-container').highcharts(_.merge({
    subtitle: {
      text: gettext('Disk Write Stats')
    },
    series: [
      {
        name: 'Rate',
        color: '#335b83',
        type: 'line',
        data: series.data
      }, {
        name: 'Average',
        color: '#4a9de4',
        type: 'spline',
        marker: { enabled: false },
        data: (function() {
          var i,
              points = [],
              n = series.data.length;
          for (i = 0; i < n; i++) {
            points.push({
              x: series.data[i].x,
              y: Math.round(series.average * 100) / 100
            });
          }
          return points;
      }())
    }],
    tooltip: getServerStatTooltip(series, false, openstackTitleFlag, false)
  }, options));
}


  /* Draw chart of network stats with server history events added as markers
   * on the line.
   * Args:
   *     startTime: epoch seconds
   *     interval: seconds between each x value
   *     netUsageValues: array of float numbers representing network usage
   *     serverEvents: array of event objects
   *     options: Highchart options object
   */
  function drawServerNetStatsChart(
      startTime, interval, netUsageValues, serverEvents, options, openstackTitleFlag) {
    if (netUsageValues === undefined) {
        netUsageValues = [];
    }

    // array of event objects sorted chronologically
    var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
    var series = seriesData(startTime, interval, netUsageValues, serverEventsSorted, false);
    var titleText = 'Network Stats';
    if(openstackTitleFlag == true){
      titleText = "Network Incoming Stats";
    }

    $('#net-container').highcharts(_.merge({
      subtitle: {
        text: gettext(titleText)
      },
      series: [
        {
          name: 'Throughput',
          color: '#335b83',
          type: 'line',
          data: series.data
        }, {
          name: 'Average',
          color: '#4a9de4',
          type: 'spline',
          marker: { enabled: false },
          data: (function() {
            var i,
                points = [],
                n = series.data.length;
            for (i = 0; i < n; i++) {
              points.push({
                x: series.data[i].x,
                y: Math.round(series.average * 100) / 100
              });
            }
            return points;
        }())
      }],
      tooltip: getServerStatTooltip(series, false, openstackTitleFlag, false)
    }, options));
  }

  function drawServerNetOutgoingStatsChart(
    startTime, interval, netUsageValues, serverEvents, options, openstackTitleFlag) {
  if (netUsageValues === undefined) {
      netUsageValues = [];
  }

  // array of event objects sorted chronologically
  var serverEventsSorted = _.sortBy(serverEvents, 'epoch_ms');
  var series = seriesData(startTime, interval, netUsageValues, serverEventsSorted, false);

  $('#net-outgoing-container').highcharts(_.merge({
    subtitle: {
      text: gettext('Network Outgoing Stats')
    },
    series: [
      {
        name: 'Throughput',
        color: '#335b83',
        type: 'line',
        data: series.data
      }, {
        name: 'Average',
        color: '#4a9de4',
        type: 'spline',
        marker: { enabled: false },
        data: (function() {
          var i,
              points = [],
              n = series.data.length;
          for (i = 0; i < n; i++) {
            points.push({
              x: series.data[i].x,
              y: Math.round(series.average * 100) / 100
            });
          }
          return points;
      }())
    }],
    tooltip: getServerStatTooltip(series, false, openstackTitleFlag, false)
  }, options));
}

  // expose public functions
  c2.chartsServerStats = {
    // Server stat charts with history events
    commonStatChartOpts: commonStatChartOpts,
    openstackCPUStatChartOpts: openstackCPUStatChartOpts,
    memStatChartOpts: memStatChartOpts,
    diskStatChartOpts: diskStatChartOpts,
    netStatChartOpts: netStatChartOpts,
    openstackDiskStatChartOpts: openstackDiskStatChartOpts,
    openstackNetStatChartOpts: openstackNetStatChartOpts,
    drawServerCPUStatsChart: drawServerCPUStatsChart,
    drawServerMemStatsChart: drawServerMemStatsChart,
    drawServerDiskStatsChart: drawServerDiskStatsChart,
    drawServerDiskWriteStatsChart: drawServerDiskWriteStatsChart,
    drawServerNetStatsChart: drawServerNetStatsChart,
    drawServerNetOutgoingStatsChart: drawServerNetOutgoingStatsChart,
  };

})(window.c2, window.$, window._, window.Highcharts);
